<div class="wrapper" [puPopover]="popover" [position]="'bc'" [offsetY]="8">
  @if (customContent()) {
    <ng-content></ng-content>
  } @else if (withoutIcon()) {
    <p class="tooltip" [ngClass]="size()">{{ text() }}</p>
  } @else {
    <pu-icon [iconName]="iconName()" size="20"> </pu-icon>
  }
</div>

<ng-template #popover>
  <p class="tooltip" [ngClass]="size()">
    {{ text() }}

    @if (isCopy()) {
      <button
        type="button"
        puButton
        uiType="quaternary"
        size="s"
        [onlyIcon]="true"
        (click)="copyToClipboard(text())">
        <pu-icon iconName="copy" size="16" />
      </button>
    }
  </p>
</ng-template>
